/**
 * AiStarLoader — animated "AI sparkle" loader, rendered as an inline SVG.
 * A concave 4-point sparkle (slow spin + pulse) with a small twinkling accent.
 * Violet-to-blue gradient, transparent background, no dependencies.
 */

import React from "react";

interface Props {
  size?: number;
}

const AI_STAR_CSS = `
.ai-star-loader .ai-star-main { transform-box: fill-box; transform-origin: center; animation: aiStarPulse 1.8s ease-in-out infinite; }
.ai-star-loader .ai-star-accent { transform-box: fill-box; transform-origin: center; animation: aiStarTwinkle 1.8s ease-in-out -0.6s infinite; }
.ai-star-loader .ai-star-accent2 { transform-box: fill-box; transform-origin: center; animation: aiStarTwinkle 1.8s ease-in-out -1.2s infinite; }
@keyframes aiStarPulse { 0%, 100% { transform: scale(0.6); } 50% { transform: scale(1.05); } }
@keyframes aiStarTwinkle { 0%, 100% { transform: scale(0.4); opacity: 0.3; } 50% { transform: scale(1.4); opacity: 1; } }
@media (prefers-reduced-motion: reduce) { .ai-star-loader, .ai-star-loader * { animation: none !important; } }
`;

const AiStarLoader: React.FC<Props> = ({ size = 40 }) => (
  <span
    aria-hidden="true"
    style={{ display: "inline-flex", width: size, height: size, lineHeight: 0 }}
  >
    <style>{AI_STAR_CSS}</style>
    <svg
      className="ai-star-loader"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="aiStarGrad" x1="6" y1="6" x2="42" y2="42" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#7C5CFF" />
          <stop offset="1" stopColor="#3B82F6" />
        </linearGradient>
      </defs>
      <path
        className="ai-star-main"
        d="M24 4 C25 15 33 23 44 24 C33 25 25 33 24 44 C23 33 15 25 4 24 C15 23 23 15 24 4 Z"
        fill="url(#aiStarGrad)"
      />
      <path
        className="ai-star-accent"
        d="M39 7 C39.4 10 41 11.6 44 12 C41 12.4 39.4 14 39 17 C38.6 14 37 12.4 34 12 C37 11.6 38.6 10 39 7 Z"
        fill="url(#aiStarGrad)"
      />
      <path
        className="ai-star-accent2"
        d="M11 31.5 C11.36 34.2 12.8 35.64 15.5 36 C12.8 36.36 11.36 37.8 11 40.5 C10.64 37.8 9.2 36.36 6.5 36 C9.2 35.64 10.64 34.2 11 31.5 Z"
        fill="url(#aiStarGrad)"
      />
    </svg>
  </span>
);

export default AiStarLoader;
